import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 14px;\n  right: 14px;\n'], ['\n  position: absolute;\n  top: 14px;\n  right: 14px;\n']);

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { utils, translations, styles } from 'gipsy-misc';
import { HeaderContainer, Title, Star, Actions, ReopenButton, ReviewButton } from './Common';
import ReviewFields from './ReviewFields';
import ReviewersStatus from './ReviewersStatus';
import Icon from '../../../../Icon';

var NeedReviewAsReviewer = function (_PureComponent) {
  _inherits(NeedReviewAsReviewer, _PureComponent);

  function NeedReviewAsReviewer() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, NeedReviewAsReviewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NeedReviewAsReviewer.__proto__ || Object.getPrototypeOf(NeedReviewAsReviewer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: null,
      loading: false
    }, _this.onChangeReviewStatus = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reviewStatus) {
        var sendReview;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.props.progressPending && _this.props.progressPending();
                sendReview = void 0;

                _this.setState({ active: reviewStatus, loading: true });

                _context.t0 = reviewStatus;
                _context.next = _context.t0 === utils.reviewstatus.reviewed ? 6 : _context.t0 === utils.reviewstatus.reopened ? 8 : 10;
                break;

              case 6:
                sendReview = _this.props.approveReview;
                return _context.abrupt('break', 10);

              case 8:
                sendReview = _this.props.reopenReview;
                return _context.abrupt('break', 10);

              case 10:
                _context.prev = 10;
                _context.t1 = sendReview;

                if (!_context.t1) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return sendReview(_this.props.review.id);

              case 15:
                _this.props.progressSuccess && _this.props.progressSuccess();
                setTimeout(function () {
                  _this.props.onChange({ paramName: 'reviewStatus', value: reviewStatus });
                }, 1000);
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t2 = _context['catch'](10);

                _this.props.progressError && _this.props.progressError();
                _this.props.handleAPIError && _this.props.handleAPIError(_context.t2);
                _this.setState({ active: null, loading: false });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[10, 19]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NeedReviewAsReviewer, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          review = _props.review,
          reviewers = _props.reviewers,
          onChangeReview = _props.onChangeReview;
      var _state = this.state,
          active = _state.active,
          loading = _state.loading;


      return React.createElement(
        HeaderContainer,
        { backgroundColor: 'white' },
        React.createElement(
          Title,
          { nomargin: true },
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.needReviewAsReviewer.title
          )
        ),
        React.createElement(ReviewFields, { onChange: onChangeReview, review: review }),
        React.createElement(
          Actions,
          { style: { marginBottom: 32 } },
          React.createElement(
            ReopenButton,
            {
              opacity: active === utils.reviewstatus.reviewed ? 0.4 : 1,
              disabled: !!active,
              rightIcon: loading && active === utils.reviewstatus.reopened ? React.createElement(LoadingIcon, { fill: 'white', icon: 'Loading' }) : null,
              onClick: function onClick() {
                return _this3.onChangeReviewStatus(utils.reviewstatus.reopened);
              } },
            translations.review.status.reopen
          ),
          React.createElement(
            ReviewButton,
            {
              opacity: active === utils.reviewstatus.reopened ? 0.4 : 1,
              disabled: !!active,
              rightIcon: loading && active === utils.reviewstatus.reviewed ? React.createElement(LoadingIcon, { fill: 'white', icon: 'Loading' }) : null,
              onClick: function onClick() {
                return _this3.onChangeReviewStatus(utils.reviewstatus.reviewed);
              } },
            translations.review.status.reviewed
          )
        ),
        React.createElement(ReviewersStatus, { reviewers: reviewers })
      );
    }
  }]);

  return NeedReviewAsReviewer;
}(PureComponent);

NeedReviewAsReviewer.propTypes = {
  review: PropTypes.object,
  reviewers: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onChangeReview: PropTypes.func.isRequired,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  approveReview: PropTypes.func,
  reopenReview: PropTypes.func
};


export default NeedReviewAsReviewer;

var LoadingIcon = styled(Icon)(_templateObject);
//# sourceMappingURL=NeedReviewAsReviewer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/NeedReviewAsReviewer.js
// module id = 1097
// module chunks = 0